import { DriveStep } from 'driver.js'
import i18n from 'i18next'

import {
  USER_LEVEL,
  UserLevel,
} from '../../../../components/Settings/definitions'

const TITLE_DRIVER = i18n.t('New training')

const getSegmentationCustomDriverSteps = (
  userLevel: UserLevel
): DriveStep[] => {
  const backboneDriveStep: DriveStep = {
    element: '#divBackboneId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t('Select one or more backbones.'),
      side: 'bottom',
      align: 'start',
    },
  }

  const fp16DriveStep: DriveStep = {
    element: '#fp16SwitchId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t(
        'Enable the FP16 model precision for faster training and inference. The performance might be slightly lower.'
      ),
      side: 'bottom',
      align: 'start',
    },
  }

  const resolutionDriveStep: DriveStep = {
    element: '#divResolutionId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t(
        'Select resolution. If custom resolution is selected, witdh and height image size values must be inserted.'
      ),
      side: 'bottom',
      align: 'start',
    },
  }

  const customDriveSteps: DriveStep[] = []
  customDriveSteps.push(backboneDriveStep)
  customDriveSteps.push(fp16DriveStep)
  if (userLevel === USER_LEVEL.expert) {
    customDriveSteps.push(resolutionDriveStep)
  }

  return customDriveSteps
}

export default getSegmentationCustomDriverSteps
